import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import ServicesCardSection from "../ItPage/ServicesCardSection/ServicesCardSection";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import BgvStepsSection from "../ItPage/BgvStepsSection/BgvStepsSection";
import BgvServiceSection from "../ItPage/BgvServiceSection/BgvServiceSection";
import BrandCarousel from "../ItPage/BrandCarousel/BrandCarousel";
import ButtonComponent from "../../Components/Buttons/ButtonComponent";
import { Helmet } from "react-helmet";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";

const bg_image = `${digitalOceanURL}/About_Us_img/About_bg.png`;
const Banking_img = `${digitalOceanURL}/Sector/Banking.png`;

export default function Banking() {
  
  return (
    <>
      <Helmet>
        <title>
          Blockchain-powered and AI-driven Employee Verification for Banking Sector |
          Hirestar.io
        </title>
        <meta
          name="description"
          content="Secure your banking workforce with Hirestar.io's blockchain-powered employee verification. Ensure trust, compliance, and fraud prevention with automated background checks."
        />
        <meta
          name="keywords"
          content="banking employee verification, blockchain background checks, secure hiring, KYC compliance, background verification for banks, aadhaar verification,voter id verification, driving license verification, liveness verification,udyog aadhaar, aadhaar masking,address verification,uan verification,pan verification, gstin verification,din verification,icsi verification,bank statement analyzer,epfo verification, tin verification"
        />
        <meta
          property="og:title"
          content="Blockchain-powered Employee Verification for Banking Sector | Hirestar.io"
        />
        
        <meta
          property="og:description"
          content="Hirestar.io provides secure and compliant employee verification for the banking sector using blockchain technology. Fast, reliable, and automated."
        />
        <meta
          property="og:url"
          content="https://hirestar.io/industries/banking"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={Banking_img} />
        <meta property="og:image:type" content="image/png" />

        <meta property="og:site_name" content="Hirestar.io"/>
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Blockchain-Based Employee Verification for Banking Sector | Hirestar.io"
        />
        <meta
          name="twitter:description"
          content="Ensure compliance and security in banking with Hirestar.io's blockchain-backed background checks and verification services."
        />
        <meta name="twitter:image" content={Banking_img} />
        <meta property="og:locale" content="en_US" />
      </Helmet>

      <div className="relative  background_color  ">
        {/* Image that is hidden on small screens */}
        <img
          src={bg_image}
          alt="hero img for banking sector"
          className="absolute  object-cover w-full lg:h-[150%] h-[110%] md:h-[120%] bg_curve_img"
        />

        <div className="mb-16 relative  w-full h-full md:top-28 lg:top-0 ">
          <div className="grid grid-cols-12 gap-4 justify-items-center relative top-0 lg:top-32 lg:mx-20 xl:mx-32 2xl:mx-40 items-center ">
            {/* Text container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-7  Banking_heading font-semibold font-[poppins]  top_spacing mx-2 lg:mx-0">
              <span className="industry_info">
                Banking and Financial Services
              </span>
              <h1 className="w-full text-[32px] md:text-[40px] lg:text-[46px]">
                Your Reliable All in One AI-Driven Fraud Prevention and Risk
                Management
              </h1>
              {/* h2 heading */}
              <h2 className="about-text-para mt-2 ">
                Enhance your operations with solutions that comply with
                regulations and foster trust throughout your digital onboarding
                and verification processes.
              </h2>

              {/* Button Group */}
              <div className="mt-4">
                <ButtonComponent
                  arialLabel={
                    "Get in touch with an expert for automated background checks in Banking sector"
                  }
                />
              </div>
            </div>

            {/* Image container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-5 relative   lg:-top-8 bottom_space lg:mb-0 mb-20">
              <img
                src={Banking_img}
                alt="about-girl banking sector"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="lg:mt-[24rem] md:mt-[12rem] mt-[8rem]">
        <BrandCarousel />
      </div>
      {/* 3 section */}
      <BgvServiceSection Sector="Banking Sector" />
      {/* 4 section */}
      {/* 5 section */}
      <ServicesCardSection Sector_cards="banking" Sector="Banking Sector" />

      <div className="mb-48">{<BgvStepsSection />}</div>

      <FaqComponent />
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
}
